//const hideOptions=['certs','options','verify','reports'];
const hideOptions= [];
export default hideOptions;